import CloseIcon from '@mui/icons-material/Close';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import { Theme } from '@mui/material';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container/Container';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import MobileStepper from '@mui/material/MobileStepper';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Illustration } from '../../image/Illustration';
import "./TooltipDialog.css";

function TooltipDialog(props: any) {
    const { t } = useTranslation();
    const [open, setOpen] = useState(false);
    const [currentStep, setCurrentStep] = useState(0);

    const previousPage = () => {
        setCurrentStep((prevActiveStep) => prevActiveStep - 1);
    };

    const nextPage = () => {
        setCurrentStep((prevActiveStep) => prevActiveStep + 1);
    };

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setCurrentStep(0);
    };

    return (
        <>
            {(props.steps === 1) ?
                <div onClick={handleClickOpen}>{props.button}</div>
                : <Button className="tutorial-dialog-button" onClick={handleClickOpen}>{props.button}</Button>
            }
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <IconButton
                    onClick={handleClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme: Theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
                <DialogTitle id="alert-dialog-title" align="center" sx={{ mx: "1.5rem", mt: "1rem", fontWeight: "semibold", lineHeight: "normal" }}>
                    {props.content[currentStep][0]}
                </DialogTitle>
                <DialogContent>
                <DialogContentText className="dialog-content-text" id="alert-dialog-description" align="center" sx={{ mx: "1.5rem", mb: "1.5rem", fontSize: "smaller" }}>
                        {props.content[currentStep][1]}
                    </DialogContentText>
                    {props.content[currentStep][2] !== undefined ?
                        <Container fixed disableGutters>
                            <Illustration className='illustration-size' src={process.env.PUBLIC_URL + props.content[currentStep][2]} alt="Electric vehicle charging simulation" loading="lazy" />
                        </Container>
                        : null
                    }
                </DialogContent>
                <DialogActions>
                    {props.steps === 1 ?
                        <Button variant="contained" sx={{ mx: "auto", mb: "1rem", px: "3rem" }} color="error" onClick={handleClose}>{props.action ? props.action : null}</Button>
                        : <MobileStepper
                            sx={{ backgroundColor: "#FFFFFF", mx: "auto", mb: "1rem" }}
                            variant="dots"
                            steps={props.steps}
                            position="static"
                            activeStep={currentStep}
                            nextButton={
                                <Button sx={{ mx: "auto" }} color="error" size="small" onClick={nextPage} disabled={currentStep === props.steps - 1}>
                                    <KeyboardArrowRight />{t("mobile-stepper.next")}
                                </Button>
                            }
                            backButton={
                                <Button sx={{ mx: "auto" }} color="error" size="small" onClick={previousPage} disabled={currentStep === 0}>
                                    {t("mobile-stepper.previous")}<KeyboardArrowLeft />
                                </Button>
                            }
                        />}
                </DialogActions>
            </Dialog>
        </>
    );
}

export default TooltipDialog;